var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data"},[_c('img',{attrs:{"src":require("./../../assets/img/no_data.jpg"),"alt":"","srcset":""}}),_c('div',[_vm._v("暂无内容哦")])])
}]

export { render, staticRenderFns }